<script>
    import { get_attribute_value, get_attribute_name } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724612';

    export let product;

    $: features = get_features(product);

    function get_features(product) {
        const list = [];

        []
            .concat(
                get_attribute_name(product, 'kw_top_equipment_backpacks') || [],
                get_attribute_name(product, 'kw_top_equipmemt_bags') || [],
                get_attribute_name(product, 'kw_top_equipmemt_diverses') || []
            )
            .map((name) => {
                list.push(...name.split(', '));
            });
        if (list.length == 0) {
            return undefined;
        }

        return list;
    }
</script>

<div class="u-line--bottom m-product-features">
    <ul>
        {#if features}
            {#each features as feature}
                <li>{feature}</li>
            {/each}
        {/if}
    </ul>
</div>

<style>
    ul{
        list-style-type: none;
        padding-left: 0;
        margin: 5px 0;
    }
    ul li::before{
        color: #71C062;
        font-weight: bold;
    }
     ul li{
        padding: 2px 0px;
        display: flex;
        align-items: center;
     }
    
</style>